import { ONE_MINUTE_MS } from '~/shared/constants/time'

export const DEFAULT_SCALE_MS = 30 * ONE_MINUTE_MS
export const DEFAULT_DURATION_MS = 150 * ONE_MINUTE_MS

export type EpgTimeLine = {
  scale: number
  duration: number
  firstDayStamp: number
}
